export default "__VITE_ASSET__BqGK0BgV__"